<template>
  <div class="park_area">
    <page-box :title="'园区面积数据'">
      <div class="content">
        <div class="overview">
          <div class="item" v-for="(item, index) in overviewData" :key="index">
            <div class="icon_conatiner">
              <img :src="item.icon" alt="" class="icon" />
            </div>
            <div class="text_container">
              <div class="name">{{ item.name }}</div>
              <div class="number_content">
                <div class="number">{{ item.number }}</div>
                <div class="fon">{{ item.fon }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </page-box>
  </div>
</template>

<script setup>
import PageBox from '@/components/pageBox/PageBox';
import { ref, reactive, onMounted } from 'vue';
import MyEcharts from '@/baseCpm/MyEcharts/MyEcharts.vue';
import * as echarts from 'echarts';
const overviewData = ref([
  {
    name: '占地面积',
    number: 22,
    fon: '亩',
    icon: require('@/assets/images/Industry/1.png'),
  },
  {
    name: '建筑面积',
    number: 22,
    fon: '万m²',
    icon: require('@/assets/images/Industry/2.png'),
  },
  {
    name: '总房间数',
    number: 5340,
    fon: '',
    icon: require('@/assets/images/Industry/3.png'),
  },
  {
    name: '产业面积',
    number: 12,
    fon: '万m²',
    icon: require('@/assets/images/Industry/4.png'),
  },
  {
    name: '商业面积',
    number: 5.6,
    fon: '万m²',
    icon: require('@/assets/images/Industry/5.png'),
  },
  {
    name: '可租售面积',
    number: 2.5,
    fon: '万m²',
    icon: require('@/assets/images/Industry/6.png'),
  },
]);
</script>

<style lang="scss" scoped>
.park_area {
  margin-bottom: 5px;
  .content {
    margin-left: 20px;
    // margin-top: 21px;
    width: 310px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .overview {
      margin-top: 10px;
      width: 310px;
      height: 208.66px;
      display: flex;
      justify-content: space-between;
      align-content: space-between;
      flex-wrap: wrap;
      .item {
        width: 140px;
        height: 55px;
        background-size: 100% 100%;
        background-image: url(@/assets/images/Industry/textbg.png);
        display: flex;
        justify-content: space-between;
        align-items: center;
        .icon_conatiner {
          width: 63.64px;
          height: 63.64px;
          display: flex;
          align-items: center;
          justify-content: center;
          .icon {
            width: 20px;
            height: 20px;
          }
        }
        .text_container {
          width: 95px;
          .name {
            color: rgba(250, 254, 255, 0.7);
            font-family: MiSansM;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 19.2px; /* 137.143% */
          }
          .number_content {
            display: flex;
            justify-content: flex-start;
            align-items: baseline;
            .number {
              color: #ffec90;
              text-align: center;
              font-family: MiSansS;
              font-size: 20px;
              font-style: normal;
              font-weight: 600;
              line-height: normal;
            }
            .fon {
              color: rgba(255, 236, 144, 0.7);
              font-family: MiSans;
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
              line-height: 19.2px; /* 137.143% */
            }
          }
        }
      }
    }
    .echarts_content {
      margin-top: -5px;
      width: 349.117px;
      height: 176.385px;
    }
  }
}
</style>
